'use client';
/* eslint-disable @next/next/no-img-element */
import { ElementProps } from '@/components/sections/builder/types';
import { useParams } from 'next/navigation';

import { BlogDetailTitleElementDataType } from '@/components/sections/builder/elements/body/blog-detail/type';
import { WrapperChild } from '@/components/sections/builder/wrapper';
import { useBlogsDetails } from '@/hooks/api/storefront/blogs';
import { IBlogPost } from '@/types/blog';

export default function ElementContent({ element, preview }: ElementProps) {
  const childs = element.childs;
  const content = element.data as BlogDetailTitleElementDataType;

  const { slug: blogSlug } = useParams<{ slug: string }>();

  const { data: blogDetails } = useBlogsDetails(blogSlug, {
    enabled: !!blogSlug,
  });
  const details = blogDetails || ({} as IBlogPost);

  return (
    <>
      <section className='bg_section'>
        <div className='theme_layout_page_width mx-auto duration-100'>
          <div className='theme_layout_space_section'>
            <div className='relative px-6 py-6 lg:px-6 lg:py-8'>
              {(childs || []).map((child) => (
                <WrapperChild
                  child={{
                    ...child,
                    parentData: details,
                  }}
                  parentType={element.type}
                  key={child.id}
                  preview={preview}
                  className=''
                />
              ))}
            </div>
          </div>
        </div>
        {/* <div>
        
        </div> */}
      </section>
      <style jsx>
        {`
          .bg_section {
            background-color: ${content.colorSchemeSection?.background || 'white'};
          }
        `}
      </style>
    </>
  );
}
